module.exports = __webpack_public_path__ + "static/ageas-white-a367f6826739182a8e143fc03f273bf7.svg";